<div class="row do-not-print">
  <div class="col-md-10 offset-md-2 text-left my-3 col-12">
    <h1 class="title">{{title}}</h1>
  </div>
</div>

<div class="row">
  <div class="card offset-md-2 col-md-10 col-print-12 col-12 odp-xs-card-margin-top">
    <div class="card-body text-left">
      <div *ngIf="isCreate; then createAbstract else viewEditAbstract"></div>

      <ng-template #createAbstract>
        <app-abstract-form [userName]="userName" (cancel)="router.navigateByUrl('/home/actions')"></app-abstract-form>
      </ng-template>

      <ng-template #viewEditAbstract>
        <div *ngIf="isEdit; then editAbstract else viewAbstract"></div>

        <ng-template #viewAbstract>
          <app-view-abstract [abstract]="abstract" [userName]="userName" [fullName]="fullName"
            (editing)="toggleViewEdit($event)"></app-view-abstract>
        </ng-template>

        <ng-template #editAbstract>
          <app-abstract-form [abstract]="abstract" [userName]="userName" (updated)="updateView($event)"
            (cancel)="toggleViewEdit($event)"></app-abstract-form>
        </ng-template>
      </ng-template>

    </div>
  </div>
</div>
